import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';
import { Address } from './Address';
import { Entity } from './Entity';

@supertypeClass({ toClient: true, toServer: true })
export class CollateralAssignment extends Persistable(Remoteable(Supertype)) {
  @property({
    rule: 'required',
    comment: 'Collateral Assignee',
  })
  assignee: Entity;

  @property({
    rule: 'required',
    comment: 'Purpose of Loan',
  })
  loanPurpose: string;

  @property({
    rule: ['numeric', 'required'],
    comment: 'Duration of Loan',
  })
  loanDuration: number;

  @property({
    rule: 'required',
    comment: 'Is the loan an Small Business Administration (SBA) loan?',
  })
  isSBALoan: string;

  @property({
    rule: 'required',
    comment: 'Details about the repayment terms of the loan',
  })
  loanRepaymentDetails: string;

  @property({
    rule: 'required',
    comment: 'Name of Loan Officer',
  })
  loanOfficerName: string;

  @property({
    rule: ['required', 'email'],
    comment: 'Email Address of Loan Officer',
  })
  loanOfficerEmail: string;

  constructor() {
    super();
  }

  static new() {
    return new CollateralAssignment().init();
  }

  init() {
    const EntityClass = Entity,
      AddressClass = Address;

    this.assignee = EntityClass.new();
    this.assignee.legalAddress = AddressClass.new();

    return this;
  }
}
